export default __webpack_public_path__ + "static/media/share-solid.ab6a1852.svg";